import { DefaultAttributeValue } from '@source-components-react/types';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: 'cloudinary-cloud-name',
    defaultValues: {},
  },
  {
    name: 'cloudinary-public-id',
    defaultValues: {},
  },
  {
    name: 'media-selector-3-resolutions',
    defaultValues: {
      all: 'main-sample',
    },
  },
  {
    name: 'pass-through-image-attributes-alt-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-width-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-height-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-sizes-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-loading-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'pass-through-image-attributes-fetchpriority-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'cloudinary-transformations-3-resolutions',
    defaultValues: {},
  },
];
